import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { SERVICES } from "@/data/services";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputClass =
  "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition-colors placeholder:text-slate-400 focus:border-brand focus:ring-2 focus:ring-brand/20";

const ContactForm = () => {
  const [form, setForm] = useState({ name: "", phone: "", service: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim() || !form.message.trim()) {
      toast.error("Completa tu nombre, teléfono y mensaje.");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("¡Mensaje enviado! Te contactaremos muy pronto.");
      setForm({ name: "", phone: "", service: "", message: "" });
    } catch {
      toast.error("No pudimos enviar tu mensaje. Intenta por WhatsApp.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="rounded-3xl border border-slate-100 bg-white p-6 shadow-[0_10px_30px_-10px_rgba(0,183,205,0.12)] md:p-8"
      data-testid="contact-form"
    >
      <h2 className="font-display text-lg font-bold text-slate-900">Envíanos un mensaje</h2>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="contact-name" className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-500">Nombre</label>
          <input id="contact-name" type="text" placeholder="Tu nombre completo" className={inputClass} value={form.name} onChange={set("name")} data-testid="contact-form-name-input" />
        </div>
        <div>
          <label htmlFor="contact-phone" className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-500">Teléfono</label>
          <input id="contact-phone" type="tel" placeholder="300 123 4567" className={inputClass} value={form.phone} onChange={set("phone")} data-testid="contact-form-phone-input" />
        </div>
        <div className="sm:col-span-2">
          <label htmlFor="contact-service" className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-500">Servicio de interés</label>
          <select id="contact-service" className={inputClass} value={form.service} onChange={set("service")} data-testid="contact-form-service-select">
            <option value="">Selecciona un servicio (opcional)</option>
            {SERVICES.map((s) => (
              <option key={s.slug} value={s.name}>{s.name}</option>
            ))}
          </select>
        </div>
        <div className="sm:col-span-2">
          <label htmlFor="contact-message" className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-500">Mensaje</label>
          <textarea id="contact-message" rows={4} placeholder="Cuéntanos qué necesitas limpiar y en qué sector estás..." className={inputClass} value={form.message} onChange={set("message")} data-testid="contact-form-message-input" />
        </div>
      </div>
      <button
        type="submit"
        disabled={sending}
        className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-brand px-6 py-4 text-sm font-bold text-white transition-colors hover:bg-brand-dark disabled:opacity-60"
        data-testid="contact-form-submit-button"
      >
        <Send size={17} /> {sending ? "Enviando..." : "Enviar mensaje"}
      </button>
      <p className="mt-3 text-center text-xs text-slate-400">
        También puedes escribirnos directo por WhatsApp para una respuesta más rápida.
      </p>
    </form>
  );
};

export default ContactForm;
